// Keep each ACE identity lookup bounded to one request. The canonical save is
// insert-only; retries reuse previously registered certs rather than duplicate.
export async function registerCount(api,{certs,boxCode,newUse,useForCert=()=>newUse,recordExistingMix=false,onProgress=()=>{}}){
  const queue=[...new Set(certs)];let cursor=0,completed=0,added=0;const failures=[];
  async function worker(){
    while(cursor<queue.length){
      const cert=queue[cursor++];
      try{
        const result=await api.storage({operation:'registerExisting',certNumber:cert,boxCode,newUse:useForCert(cert),...(recordExistingMix?{recordExistingMix:true}:{})});
        if(result.registered!==true||result.certNumber!==cert)throw Error('Registration could not be verified. Retry this count.');
        if(result.created)added++;
      }catch(error){failures.push({cert,message:error.message});}
      completed++;onProgress({completed,total:queue.length,added});
    }
  }
  await Promise.all(Array.from({length:Math.min(2,queue.length)},worker));
  return {completed,added,failures};
}
